import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

class PreventNav extends Component {
  constructor(props) {
    super(props);

    this.unmountHandler = this.handleBeforeUnload.bind(this);
  }

  handleBeforeUnload(e) {
    const { sale } = this.props;
    const msg = undefined;
    if (Object.keys((sale.sale || {}).packages || {}).length > 0) {
      e.preventDefault();
      const msg = sale.done
        ? 'Are you sure you want to leave? You may want to print your ticket first?'
        : 'Are you sure you want to leave? You will lose the items in your cart.';
      e.returnValue = msg;
    } else {
      delete e['returnValue'];
    }

    return msg;
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.unmountHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.unmountHandler);
  }

  render() {
    return <span />;
  }
}

PreventNav.propTypes = {
  sale: PropTypes.object
};

const mapStateToProps = state => ({
  sale: state.sale
});

export default connect(mapStateToProps)(withRouter(PreventNav));
